export const useQueryConfig = {
    refetchOnWindowFocus: false,
    retry: 0,
}
